// Function to deselect all text
export const clearTextSelection = () => {
  // Clear any actual text selection
  if (window.getSelection) {
    window.getSelection().removeAllRanges();
  } else if (document.selection) {
    document.selection.empty();
  }
};

// Function to deselect all text
export const clearSelection = (targetDiv) => {
  targetDiv.classList.remove("annotation-selection");
};

export const makeSelection = (targetDiv) => {
  targetDiv.classList.add("annotation-selection");
};
